{
  "access": {
    "board": {
      "title": "Mes accès",
      "mapTitle": "Ce à quoi j'ai accès",
      "leads": "Votre responsable :",
      "why": "Pourquoi ?",
      "hideWhy": "Masquer",
      "whyLoading": "Chargement…",
      "whyError": "Chargement impossible.",
      "requestsTitle": "Mes demandes",
      "requestedRole": "Demandé : {{role}}",
      "cancel": "Retirer",
      "cancelling": "Retrait…",
      "empty": {
        "title": "Aucun accès pour l'instant",
        "description": "Les ressources auxquelles vous pouvez accéder apparaissent ici dès qu'elles sont partagées avec vous ou votre équipe."
      },
      "noRequests": {
        "title": "Aucune demande en cours",
        "description": "Les accès que vous demandez apparaissent ici avec leur statut."
      },
      "loadError": "Impossible de charger votre aperçu des accès.",
      "resourceTypeError": "Impossible de charger {{type}} — certains accès peuvent ne pas être affichés.",
      "chatPlaceholder": "Posez une question sur vos accès…"
    },
    "openAssistant": "Ouvrir l'assistant Mes accès",
    "team": {
      "title": "Accès de l'équipe",
      "summary": "{{members}} membres · {{requests}} demandes en cours",
      "openAssistant": "Ouvrir l'assistant Accès de l'équipe",
      "inbox": {
        "title": "Approbations",
        "approve": "Approuver",
        "deny": "Refuser",
        "deciding": "Traitement…",
        "confirmDeny": "Envoyer le refus",
        "cancel": "Annuler",
        "denyReasonLabel": "Motif (facultatif)",
        "denyReasonPlaceholder": "Pourquoi cette demande est-elle refusée ?",
        "empty": {
          "title": "Boîte vide",
          "description": "Les demandes d'accès de votre équipe apparaissent ici pour approbation ou refus."
        }
      },
      "composer": {
        "title": "Accorder un accès",
        "who": "Qui",
        "whoPlaceholder": "Choisir une personne ou un groupe de rôle",
        "what": "Ressource",
        "whatPlaceholder": "Choisir une ressource",
        "role": "Rôle",
        "membersGroup": "Personnes",
        "rolesGroup": "Groupes de rôle",
        "expiry": "Expire",
        "expiryChoice": {
          "end_of_shift": "Fin de service",
          "permanent": "Sans expiration",
          "until": "Jusqu'à…"
        },
        "untilLabel": "Expire le",
        "grant": "Accorder",
        "granting": "Attribution…",
        "relativeHours": "+{{hours}} h"
      },
      "roster": {
        "title": "Composition de l'équipe",
        "otherGroup": "Autres",
        "expiringSoon": "Expire bientôt",
        "grants_one": "Accès",
        "grants_other": "Accès",
        "moreGrants": "+{{count}} autres",
        "openRequests_one": "{{count}} demande en cours",
        "openRequests_other": "{{count}} demandes en cours",
        "revoke": "Révoquer l'accès",
        "empty": {
          "title": "Aucun membre",
          "description": "Les membres de votre équipe apparaissent ici avec leurs accès."
        }
      },
      "loadError": "Impossible de charger le tableau des accès de l'équipe.",
      "chatPlaceholder": "Demandez à l'assistant de proposer un accès…",
      "switchUnit": "Changer d'unité",
      "leadOnly": {
        "title": "Réservé aux responsables d'unité",
        "description": "Seul le responsable de cette unité peut voir le tableau des accès de l'équipe."
      },
      "notFramed": "Cette conversation n’est pas encore rattachée à une unité."
    },
    "proposal": {
      "action": {
        "grant": "Accorder un accès",
        "revoke": "Révoquer l'accès",
        "approve": "Approuver la demande"
      },
      "confirm": {
        "grant": "Accorder",
        "revoke": "Révoquer",
        "approve": "Approuver"
      },
      "confirming": "Traitement…",
      "dismiss": "Ignorer"
    },
    "request": {
      "title": "Aucun accès",
      "lockedType": "{{type}} — vous n'y avez pas accès",
      "canSee": "Vous pouvez toujours ouvrir",
      "sent": "Demande envoyée",
      "alreadyAuthorized": "Vous avez déjà accès",
      "alreadyPending": "Demande déjà en cours",
      "justificationPlaceholder": "Pourquoi avez-vous besoin d'un accès ? (facultatif)",
      "request": "Demander l'accès",
      "sending": "Envoi…",
      "addJustification": "Ajouter un motif",
      "thisResource": "Cette conversation"
    },
    "explanation": {
      "title": "Comment vous y accédez"
    },
    "source": {
      "direct": "direct",
      "group_membership": "via rôle",
      "org_cascade": "via unité",
      "patient_care_team": "via équipe de soins",
      "team_supervision": "via supervision",
      "public": "toute l'organisation",
      "admin": "dérogation admin",
      "inherited": "hérité"
    },
    "role": {
      "viewer": "Lecteur",
      "editor": "Éditeur",
      "owner": "Propriétaire",
      "nurse": "Infirmier",
      "shift_coordinator": "Coordination d'équipe",
      "therapist": "Thérapeute"
    },
    "relation": {
      "member": "membre de",
      "staffs": "en poste sur",
      "cares_for": "soigne",
      "covers": "remplace",
      "shared_with": "partagé directement",
      "org_wide": "partagé à toute l'organisation",
      "entitled": "autorisé pour",
      "platform_admin": "admin de la plateforme",
      "unit_lead": "responsable d'unité"
    },
    "resourceType": {
      "patient_one": "Patient",
      "patient_other": "Patients",
      "session_one": "Session",
      "session_other": "Sessions",
      "document_one": "Document",
      "document_other": "Documents",
      "feature_one": "Fonction",
      "feature_other": "Fonctions",
      "unit_one": "Unité",
      "unit_other": "Unités"
    },
    "locationKind": {
      "hospital": "Hôpital",
      "building": "Bâtiment",
      "ward": "Unité de soins",
      "icu": "USI",
      "bed": "Lit"
    },
    "expiry": {
      "min_one": "dans {{count}} min",
      "min_other": "dans {{count}} min",
      "hour_one": "dans {{count}} h",
      "hour_other": "dans {{count}} h",
      "day_one": "dans {{count}} jour",
      "day_other": "dans {{count}} jours",
      "expired": "expiré"
    },
    "status": {
      "pending": "En attente",
      "approved": "Approuvé",
      "denied": "Refusé",
      "expired": "Expiré",
      "cancelled": "Retiré"
    },
    "patient": {
      "requestDemographics": "Demander les détails"
    },
    "unitScope": {
      "choose": {
        "title": "Choisir une unité",
        "description": "Vous pouvez gérer plusieurs unités. Choisissez celle avec laquelle travailler.",
        "error": "L'unité n'a pas pu être définie. Choisissez à nouveau pour réessayer."
      },
      "noAuthority": {
        "title": "Pas encore d'unité",
        "description": "Ce tableau est destiné aux responsables d'unité. Indiquez votre lieu de travail dans votre profil ou demandez à un administrateur de vous désigner responsable d'une unité.",
        "descriptionWithUnit": "Ce tableau est destiné aux responsables d'unité. Vous travaillez dans {{unit}}, mais n'en êtes pas encore responsable — demandez à un administrateur de vous désigner responsable, ou indiquez un autre lieu de travail.",
        "setWorkplace": "Définir mon lieu de travail"
      }
    }
  },
  "org": {
    "accessRequests": {
      "title": "Demandes d'accès",
      "requestAccess": "Demander l'accès",
      "sent": "Demande envoyée au responsable de l'unité.",
      "alreadyPending": "Vous avez déjà une demande en attente pour cette unité.",
      "approve": "Approuver",
      "deny": "Refuser",
      "alreadyAuthorized": "Vous avez déjà accès."
    },
    "labels": {
      "title": "Étiquettes (optionnel)",
      "keyPlaceholder": "clé",
      "valuePlaceholder": "valeur",
      "remove": "Supprimer l'étiquette",
      "addLabel": "Ajouter une étiquette"
    },
    "accessLevel": {
      "viewer": "lecteur",
      "editor": "éditeur",
      "owner": "propriétaire"
    },
    "location": {
      "editTitle": "Modifier l'unité",
      "newTitle": "Nouvelle unité",
      "editDesc": "Renommez cette unité ou ajustez ses étiquettes. Son type et sa place dans l'arborescence ne changent pas ici.",
      "newChildDesc": "Une nouvelle unité au sein de {{parent}}.",
      "newRootDesc": "Une nouvelle unité de premier niveau (p. ex. un hôpital).",
      "kindLabel": "Type",
      "namePlaceholder": "p. ex. Soins intensifs 2",
      "noKinds": "Aucun type configuré"
    },
    "move": {
      "title": "Déplacer {{name}}",
      "desc": "Choisissez une nouvelle unité parente. L'accès se propage de haut en bas : déplacer une unité déplace tout son sous-arbre.",
      "topLevel": "— Premier niveau (aucun parent) —",
      "button": "Déplacer"
    },
    "assign": {
      "title": "Attribuer à {{name}}",
      "desc": "Donnez à une personne ou à tout un rôle l'accès à cette unité. Lecteur y travaille · éditeur la gère · propriétaire la dirige. L'accès se propage à chaque sous-unité.",
      "person": "Personne",
      "role": "Rôle",
      "selectRole": "Choisir un rôle…",
      "accessLevel": "Niveau d'accès",
      "button": "Attribuer"
    },
    "admit": {
      "title": "Admettre un patient dans {{name}}",
      "desc": "Choisissez un patient à placer dans cette unité. S'il se trouve déjà dans une autre unité, il y est transféré."
    },
    "role": {
      "editTitle": "Modifier le rôle",
      "newTitle": "Nouveau rôle",
      "desc": "Un rôle est un groupe nommé de personnes. Attribuez-le à des unités et des ressources ; ses membres héritent de l'accès.",
      "namePlaceholder": "p. ex. Infirmiers soins intensifs",
      "descLabel": "Description (optionnel)",
      "descPlaceholder": "À quoi sert ce rôle",
      "selfSelectable": "Sélectionnable soi-même lors de l'intégration"
    },
    "roleMember": {
      "title": "Ajouter un membre à {{name}}",
      "desc": "Tous les membres de ce rôle héritent de son accès aux unités et aux ressources."
    },
    "grant": {
      "title": "Accorder l'accès · {{name}}",
      "desc": "Permettez à tous les membres de ce rôle d'atteindre une ressource précise au niveau choisi.",
      "resourceTypeLabel": "Type de ressource",
      "noResourceTypes": "Aucun type de ressource configuré",
      "resourceIdLabel": "ID de ressource",
      "resourceIdPlaceholder": "l'identifiant de la ressource",
      "button": "Accorder"
    },
    "console": {
      "locations": "Emplacements",
      "roles": "Rôles"
    },
    "locationsView": {
      "units": "Unités",
      "new": "+ Nouveau",
      "emptyTitle": "Aucune unité",
      "emptyHint": "Créez votre hôpital pour démarrer l'arborescence, puis ajoutez-y bâtiments, services et lits.",
      "createFirst": "Créer la première unité",
      "buildOrg": "Construisez votre organisation",
      "selectUnit": "Sélectionner une unité",
      "createFirstHint": "Créez la première unité à gauche.",
      "selectUnitHint": "Choisissez une unité à gauche pour gérer qui y travaille et quels patients elle contient."
    },
    "rolesView": {
      "roles": "Rôles",
      "new": "+ Nouveau",
      "emptyTitle": "Aucun rôle",
      "emptyHint": "Un rôle regroupe les personnes par fonction — Infirmiers soins intensifs, Médecins de service — afin de gérer l'accès une seule fois, par rôle.",
      "createRole": "Créer un rôle",
      "defineRoles": "Définissez vos rôles",
      "selectRole": "Sélectionner un rôle",
      "createFirstHint": "Créez le premier rôle à gauche.",
      "selectRoleHint": "Choisissez un rôle pour gérer ses membres et ce qu'il peut atteindre."
    },
    "ui": {
      "patientCount": "{{count}} patient",
      "patientCount_other": "{{count}} patients",
      "remove": "Supprimer"
    },
    "tree": {
      "collapse": "Réduire",
      "hiddenParentTitle": "L'unité parente est hors de votre accès",
      "hiddenParent": "↑ parent masqué",
      "censusContext": "dans {{name}} et ses sous-unités",
      "addChild": "Ajouter une unité dans {{name}}"
    },
    "permissions": {
      "adminTier": "Accès admin (plateforme)",
      "targets": "Cibles",
      "targetsHint": "Les autorités de la plateforme, chaque zone admin et chaque agent que vous pouvez accorder.",
      "noTargets": "Aucune cible à accorder",
      "noTargetsHint": "La plateforme n'expose aucune zone admin à accorder. Cela signifie généralement que le modèle d'autorisation n'est pas configuré.",
      "selectTarget": "Sélectionner une cible",
      "selectTargetHint": "Choisissez à gauche une autorité de la plateforme, une zone admin ou un agent pour voir qui peut y accéder et accorder l'accès.",
      "grantAccess": "Accorder l'accès",
      "whoCanReach": "Qui peut y accéder",
      "noGrants": "Accordé à personne",
      "noGrantsHint": "Accordez à une personne ou à un rôle l'une des relations de cette cible.",
      "revokeAdminConfirm": "Retirer l'accès admin-plateforme complet pour « {{label}} » ?\n\nRetirer le dernier admin bloquera l'accès de l'organisation à l'interface admin. Ne continuez que si un autre admin subsiste.",
      "revoke": "Révoquer",
      "groupPlatform": "Plateforme",
      "groupAreas": "Zones admin",
      "groupAgents": "Agents",
      "agentRestricted": "Restreint — ouvert seulement aux personnes autorisées ici",
      "agentOpen": "Ouvert à tous — accorder n'ajoute rien",
      "areaSensitive": "Contenu inter-utilisateurs et identifiant les personnes"
    },
    "roleDetail": {
      "members": "Membres",
      "add": "+ Ajouter",
      "noMembers": "Aucun membre",
      "noMembersHint": "Ajoutez des personnes à ce rôle ; elles héritent de tout ce que le rôle peut atteindre.",
      "addMember": "Ajouter un membre",
      "accessToResources": "Accès aux ressources",
      "grant": "+ Accorder",
      "noGrants": "Aucun accès aux ressources",
      "noGrantsHint": "Accordez à ce rôle l'accès à une ressource précise (un document, une session, une unité…) au niveau lecteur, éditeur ou propriétaire.",
      "grantAccess": "Accorder l'accès",
      "truncated": "Affichage de la première page des accès — il en existe d'autres.",
      "deleteTitle": "Supprimer {{name}} ?",
      "deleteDesc": "Cela supprime le rôle et l'accès dont ses membres héritaient par son intermédiaire. Les personnes conservent tout accès qui leur a été accordé directement."
    },
    "locationDetail": {
      "tier": {
        "owner": "Propriétaires — dirigent cette unité",
        "editor": "Éditeurs — gèrent cette unité",
        "viewer": "Lecteurs — travaillent dans cette unité"
      },
      "whoHasAccess": "Qui a accès",
      "assign": "+ Attribuer",
      "noAccess": "Personne d'attribué pour l'instant",
      "noAccessHint": "Attribuez une personne ou un rôle. Lecteur travaille ici, éditeur la gère, propriétaire la dirige — et l'accès se propage à chaque sous-unité.",
      "assignSomeone": "Attribuer à quelqu'un",
      "byRole": "Par rôle",
      "inherited": "Hérité des unités parentes",
      "fromSource": "de {{source}}",
      "subtreeStaffing": "Personnel des sous-unités",
      "roleTag": "rôle",
      "roleMembersError": "Impossible de charger les membres de ce rôle",
      "roleMembersLoading": "Chargement des membres…",
      "roleMembersEmpty": "Personne dans ce rôle pour l'instant",
      "morePreview": "+{{count}} de plus",
      "roleMemberCount": "{{count}} personne : {{list}}",
      "roleMemberCount_other": "{{count}} personnes : {{list}}",
      "patientsInUnit": "Patients dans cette unité",
      "directlyInUnit": "Directement dans cette unité",
      "rolledUpHint": "Cumulé sur toutes les sous-unités. Sélectionnez une sous-unité à gauche pour admettre, faire sortir ou déplacer ses patients.",
      "discharge": "Faire sortir",
      "admit": "+ Admettre",
      "noPatients": "Aucun patient ici",
      "noPatientsHint": "Admettez un patient pour le placer dans cette unité ; le personnel attribué ici le verra automatiquement.",
      "admitPatient": "Admettre un patient",
      "labels": "Étiquettes",
      "deleteTitle": "Supprimer {{name}} ?",
      "deleteDesc": "Cela supprime l'unité et l'accès qui en découle. Une unité avec des sous-unités ou des patients admis ne peut pas être supprimée — déplacez-les ou faites-les sortir d'abord.",
      "schema": {
        "title": "Champs patient enregistrés ici",
        "yourView": "Résolu pour votre propre profession — une autre profession enregistre d’autres champs.",
        "empty": "Aucun champ patient dans cette unité",
        "emptyHint": "La base de la plateforme n’en déclare aucun pour votre profession, et aucune couche sur cette unité n’en ajoute.",
        "readOnly": "Lisible, non modifiable",
        "layers": "Couches sur la chaîne de cette unité",
        "minted": "généré par le serveur"
      }
    },
    "patientContext": {
      "title": "Contexte patient",
      "subtitle": "Ce que la plateforme enregistre sur une patiente dans cette unité, et ce que les agents qui y travaillent peuvent lire.",
      "edit": "Modifier les champs de l'unité",
      "empty": "Aucun champ n'est enregistré pour les patientes ici.",
      "sourcePlatform": "plateforme",
      "sourceOwn": "cette unité",
      "required": "obligatoire",
      "coded": "{{count}} codé(s)",
      "editTitle": "Champs patient pour {{unit}}",
      "editDescription": "Voici les champs ajoutés par cette unité. Les champs hérités se modifient là où ils ont été déclarés.",
      "noOwnFields": "Cette unité n'ajoute encore aucun champ propre.",
      "keyPlaceholder": "nom du champ, p. ex. severity",
      "values": "Valeurs autorisées (séparées par des virgules ; vide = texte libre)",
      "classes": "Classes de contexte (séparées par des virgules)",
      "codings": "Codage terminologique facultatif par valeur. Seule une valeur listée peut être codée.",
      "addField": "Ajouter un champ",
      "inheritedNote": "Hérité ici : {{keys}}",
      "reset": "Hériter de l'unité parente"
    }
  },
  "app": {
    "name": "IA pour le personnel soignant",
    "tagline": "Connaissances pour les soins intensifs"
  },
  "common": {
    "cancel": "Annuler",
    "save": "Enregistrer",
    "saving": "Enregistrement...",
    "delete": "Supprimer",
    "edit": "Modifier",
    "loading": "Chargement...",
    "updating": "Mise à jour…",
    "staleData": "Affichage des données en cache — échec de l'actualisation",
    "error": "Une erreur est survenue",
    "back": "Retour",
    "backHome": "Retour à l'accueil",
    "returnToMainAgent": "{{brand}}",
    "optional": "optionnel",
    "expand": "Développer",
    "no": "Non",
    "yes": "Oui",
    "serverStarting": "Préparation du serveur...",
    "submitting": "Envoi…",
    "dismiss": "Fermer",
    "goBack": "Retour",
    "create": "Créer",
    "add": "Ajouter",
    "name": "Nom",
    "required": "obligatoire"
  },
  "auth": {
    "login": "Se connecter",
    "register": "S'inscrire",
    "createAccount": "Créer un compte",
    "logout": "Se déconnecter",
    "email": "E-mail",
    "password": "Mot de passe",
    "confirmPassword": "Confirmer le mot de passe",
    "noAccount": "Pas encore de compte ?",
    "hasAccount": "Déjà un compte ?",
    "loginFailed": "Échec de la connexion. Veuillez vérifier vos identifiants.",
    "registerFailed": "Échec de l'inscription. Veuillez réessayer.",
    "registerClosed": "Tricorder est en avant-première fermée — les comptes se créent uniquement sur invitation. Demandez à votre responsable d'équipe de vous inviter.",
    "emailExists": "Cette adresse e-mail est déjà enregistrée.",
    "passwordMismatch": "Les mots de passe ne correspondent pas",
    "passwordPlaceholder": "Au moins 8 caractères",
    "passwordRepeatPlaceholder": "Répéter le mot de passe",
    "error": {
      "sessionExpired": "Session expirée",
      "sessionExpiredDesc": "Votre session de connexion a expiré ou était invalide. Veuillez réessayer."
    },
    "notice": {
      "alreadyVerified": "Déjà confirmé",
      "alreadyVerifiedDesc": "Votre adresse e-mail est déjà confirmée. Veuillez vous connecter."
    },
    "orEmail": "ou continuer avec un e-mail",
    "notVerified": {
      "title": "Veuillez vérifier votre e-mail",
      "description": "Ce compte n'a pas encore été vérifié. Ouvrez le lien dans l'e-mail que nous vous avons envoyé.",
      "resend": "Renvoyer la vérification"
    },
    "verify": {
      "inbox": {
        "title": "Vérifiez votre boîte de réception",
        "description": "Nous avons envoyé un lien de vérification à l'adresse ci-dessous. Ouvrez-le pour finaliser la création de votre compte.",
        "noEmail": "Vous n'avez pas reçu l'e-mail ?",
        "resend": "Renvoyer l'e-mail",
        "resent": "Envoyé. Vérifiez à nouveau votre boîte de réception."
      },
      "pending": {
        "title": "Vérification de votre e-mail…",
        "description": "Un instant, nous activons votre compte."
      },
      "invalid": {
        "title": "Lien invalide ou expiré",
        "description": "Ce lien de vérification n'est plus valide. Saisissez votre adresse e-mail pour en recevoir un nouveau.",
        "resend": "Envoyer un nouveau lien",
        "resent": "Si un compte existe, un nouveau lien est en route.",
        "backToLogin": "Retour à la connexion"
      },
      "unavailable": {
        "title": "Vérification temporairement indisponible",
        "description": "Nous n'avons pas pu vérifier le lien pour l'instant. Veuillez réessayer.",
        "retry": "Réessayer"
      },
      "resendFailed": "Impossible d'envoyer l'e-mail. Veuillez réessayer dans un instant."
    },
    "continueWithGoogle": "Continuer avec Google",
    "emailPlaceholder": "nom@hopital.ch",
    "passwordDotsPlaceholder": "••••••••",
    "registerClosedTitle": "Les comptes se créent sur invitation",
    "setPassword": {
      "title": "Définissez votre mot de passe",
      "description": "Vous êtes arrivé·e par votre invitation — choisissez un mot de passe pour activer votre compte.",
      "submit": "Activer le compte",
      "backToLogin": "Retour à la connexion",
      "invalid": {
        "title": "Ce lien est incomplet",
        "description": "Utilisez le lien de mot de passe de votre e-mail d'invitation. Pas de lien ? Demandez à votre responsable d'équipe."
      },
      "expired": "Ce lien n'est plus valable.",
      "expiredHint": "Un lien plus récent a peut-être été envoyé — utilisez l'e-mail le plus récent, ou demandez à votre responsable d'équipe.",
      "alreadySet": "Le mot de passe est déjà défini. Connectez-vous avec."
    }
  },
  "oauthConsent": {
    "heading": "Connecter « {{clientName}} » ?",
    "unnamedClient": "Application sans nom",
    "lead": "Elle demande l’accès à votre compte Tricorder, en tant que {{email}}.",
    "labelAccess": "Accès",
    "labelResource": "Ressource",
    "approve": "Autoriser",
    "deny": "Refuser",
    "errorTitle": "Échec de la connexion",
    "invalidRequest": "Ce lien de connexion est invalide ou incomplet. Relancez la connexion depuis l’application.",
    "unknownClient": "Cette application n’est pas enregistrée auprès de Tricorder. Relancez la connexion depuis l’application.",
    "submitError": "La demande n’a pas pu être finalisée. Veuillez réessayer.",
    "scopes": {
      "mcp": "Utiliser les outils Tricorder en votre nom"
    }
  },
  "home": {
    "title": "Conversations",
    "admin": "Administration",
    "assistantPrefix": "Assistant numérique",
    "showSidebar": "Afficher la barre latérale",
    "hideSidebar": "Masquer la barre latérale",
    "searchAgents": "Rechercher un agent…",
    "noAgentMatch": "Aucun agent trouvé.",
    "search": "Rechercher dans les sessions...",
    "new": "Poser une nouvelle question",
    "loadError": {
      "title": "Impossible de charger les sessions",
      "retry": "Réessayer"
    },
    "myPatients": {
      "empty": {
        "title": "Aucun·e patient·e assigné·e",
        "description": "Démarrez une garde pour voir vos patient·es ici."
      },
      "noSessions": "Pas encore de conversations pour ce·tte patient·e",
      "loadError": {
        "title": "Impossible de charger vos patient·es"
      }
    },
    "personal": {
      "empty": {
        "title": "Aucune conversation personnelle",
        "description": "Les conversations sans lien patient apparaissent ici."
      }
    },
    "team": {
      "empty": {
        "title": "Aucune conversation d’équipe",
        "description": "Le travail d’équipe au niveau du service apparaît ici."
      }
    },
    "previousPatients": {
      "row": "Patient·es précédent·es ({{count}})",
      "title": "Patient·es précédent·es",
      "empty": {
        "title": "Aucun·e patient·e précédent·e",
        "description": "Les patient·es avec qui vous avez travaillé apparaissent ici."
      },
      "noSessions": "Aucune conversation pour ce·tte patient·e"
    },
    "scope": {
      "patients": "Patients",
      "personal": "Personnel",
      "team": "Équipe"
    },
    "shift": "Mon service",
    "section": {
      "conversations": "Conversations"
    },
    "headerAction": {
      "notices": "Avis",
      "knowledge": "Savoir"
    },
    "openAgent": "Ouvrir l'agent",
    "newConversation": "Nouvelle conversation",
    "launcherFor": "Ouvrir un agent pour {{label}}",
    "noAnswerYet": "Pas encore de réponse",
    "viewSource": "Voir la source",
    "selectConversation": {
      "title": "Sélectionner une conversation",
      "description": "Choisissez une conversation pour voir la réponse et la source."
    },
    "launcherPersonal": "Ouvrir un agent personnel",
    "launcherTeam": "Ouvrir un agent d’équipe",
    "handover": {
      "receivedFrom": "Transmission de {{name}}",
      "receivedUnknown": "Transmission",
      "viewRapport": "Voir le rapport de transmission"
    }
  },
  "actions": {
    "retry": "Réessayer",
    "retrying": "Nouvel essai…",
    "report": "Signaler",
    "reported": "Signalé",
    "close": "Fermer",
    "confirm": "Confirmer",
    "submit": "Envoyer",
    "cancel": "Annuler"
  },
  "agentic": {
    "submit": "Envoyer",
    "validation": {
      "required": "Ce champ est requis",
      "invalidNumber": "Veuillez entrer un nombre valide",
      "maxValue": "La valeur doit être au plus {{max}} {{unit}}",
      "minValue": "La valeur doit être au moins {{min}} {{unit}}"
    },
    "protocol": {
      "endOfProtocol": "[Fin du protocole]",
      "nameUnavailable": "Nom du protocole indisponible",
      "badge": {
        "step": "Étape",
        "decision": "Décision",
        "observation": "Observation",
        "action": "Action",
        "terminal": "Terminal"
      }
    },
    "continue": "Continuer",
    "noLongerActive": "N'est plus actif — continuez ci-dessous",
    "pleaseSelect": "Veuillez sélectionner..."
  },
  "bookmarks": {
    "notFound": "Favori non trouvé",
    "createError": "Impossible de créer le favori."
  },
  "onboarding": {
    "validation": {
      "assistantNameRequired": "Le nom est requis"
    },
    "years": {
      "new": "Nouveau",
      "1-2": "1-2 ans",
      "2-5": "2-5 ans",
      "3-5": "3-5 ans",
      "5-10": "5-10 ans",
      "6-10": "6-10 ans",
      "10-20": "10-20 ans",
      "20+": "20+ ans"
    },
    "specialisations": {
      "icu": "Soins intensifs (USI)",
      "anesthesia": "Anesthésie",
      "emergency": "Urgences",
      "internal_medicine": "Médecine interne",
      "surgery_visceral": "Chirurgie viscérale",
      "surgery_vascular": "Chirurgie vasculaire et transplantation",
      "cardiology": "Cardiologie",
      "neurology": "Neurologie",
      "neurosurgery": "Neurochirurgie",
      "oncology": "Oncologie",
      "pneumology": "Pneumologie",
      "gastroenterology": "Gastroentérologie et hépatologie",
      "nephrology": "Immunologie de transplantation et néphrologie",
      "hematology": "Hématologie",
      "infectiology": "Infectiologie et hygiène hospitalière",
      "endocrinology": "Endocrinologie, diabétologie et métabolisme",
      "rheumatology": "Rhumatologie",
      "dermatology": "Dermatologie",
      "ophthalmology": "Ophtalmologie",
      "ent": "Oto-rhino-laryngologie (ORL)",
      "urology": "Urologie",
      "gynecology": "Gynécologie et obstétrique",
      "orthopaedics": "Orthopédie et traumatologie",
      "plastic_surgery": "Chirurgie plastique, reconstructive et de la main",
      "thoracic_surgery": "Chirurgie thoracique",
      "spinal_surgery": "Chirurgie spinale",
      "oral_maxillofacial": "Chirurgie orale et maxillo-faciale",
      "radiology": "Radiologie et médecine nucléaire",
      "radiation_oncology": "Radio-oncologie",
      "psychosomatics": "Psychosomatique",
      "clinical_pharmacology": "Pharmacologie clinique et toxicologie",
      "palliative_care": "Soins palliatifs",
      "rehabilitation": "Thérapies / Réhabilitation",
      "medical_polyclinic": "Policlinique médicale",
      "surgical_polyclinic": "Policlinique chirurgicale",
      "other": "Autre",
      "midwifery": "Obstétrique et périnatalogie"
    },
    "institutions": {
      "usb": "Hôpital universitaire de Bâle"
    },
    "languages": {
      "de": "Allemand",
      "fr": "Français",
      "en": "Anglais"
    },
    "inputPlaceholder": "Entrer une réponse..."
  },
  "profile": {
    "title": "Profil",
    "name": "Nom",
    "role": "Rôle",
    "specialisation": "Spécialisation",
    "institution": "Institution",
    "institutionEmpty": "Aucun établissement renseigné",
    "unit": "Service/Unité",
    "unitEmpty": "Aucun service assigné",
    "wardMemberships": "Également assigné par votre organisation",
    "twinName": "Nom de l'assistant",
    "language": "Langue",
    "save": "Enregistrer les modifications",
    "logout": "Se déconnecter",
    "logoutConfirm": "Voulez-vous vraiment vous déconnecter ?",
    "validation": {
      "nameRequired": "Le nom est requis"
    },
    "feedback": {
      "failedDescription": "Veuillez réessayer plus tard."
    },
    "summary": {
      "empty": {
        "description": "Démarrez des conversations avec votre collègue numérique. Votre profil de connaissances sera créé automatiquement.",
        "title": "Aucune conversation pour le moment"
      },
      "evidence": "Preuves",
      "generatedAt": "Généré",
      "messageCount": "message",
      "messageCount_other": "messages",
      "regenerate": "Mettre à jour",
      "regenerating": "Génération...",
      "title": "Profil de connaissances",
      "topics": "Domaines clés"
    },
    "yearsExperience": "Expérience",
    "yearsExperienceValue": "{{count}} ans",
    "errors": {
      "summaryGenerationFailed": "Le profil n'a pas pu être généré",
      "saveFailed": "Le profil n'a pas pu être enregistré",
      "orgOptionsLoadFailed": "Impossible de charger les options de l'organisation",
      "orgOptionsEmpty": "Rien n'est configuré pour le moment"
    },
    "narrative": "Ma pratique",
    "narrativeEmpty": "Vous n'avez encore rien écrit sur votre pratique. Touchez Modifier pour l'ajouter.",
    "narrativePlaceholder": "Avec quoi travaillez-vous, et qu'est-ce qui compte pour vous ?"
  },
  "chat": {
    "unsupportedBlock": "Contenu non pris en charge — mettez à jour l'application pour l'afficher.",
    "retiredAgentNotice": "Cet assistant n'est plus disponible. La conversation et son historique sont conservés — les réponses proviennent désormais de l'assistant général.",
    "placeholder": "Entrer une question...",
    "attach": "Ajouter une pièce jointe",
    "send": "Envoyer le message",
    "moreDetails": "Plus de détails",
    "lessDetails": "Moins",
    "showSources": "Afficher les sources",
    "hideSources": "Masquer les sources",
    "inboundSummary": {
      "viewFullSession": "Voir la session complète",
      "receiving": "Réception du résumé de la session…",
      "loadError": "Impossible de charger le résumé.",
      "retry": "Réessayer"
    },
    "streaming": {
      "searching": "Recherche en cours",
      "citationsFound": "{{count}} source(s) trouvée(s)"
    },
    "errors": {
      "llmError": "La réponse IA a échoué. Veuillez réessayer.",
      "protocolBootstrapFailed": "Le protocole n'a pas pu être démarré. Veuillez réessayer.",
      "toolCallError": "Un service est temporairement indisponible. La réponse est basée sur des connaissances générales.",
      "streamingIncomplete": "Réponse incomplète. Réessayer ?",
      "networkError": "Erreur réseau. Veuillez vérifier votre connexion.",
      "retryButton": "Réessayer",
      "retrying": "Nouvelle tentative...",
      "imageAnalysisFailed": "Je n'ai pas pu analyser l'image. Essayez de saisir le nom du médicament.",
      "responseGenerationFailed": "Je n'ai pas pu générer de réponse. Veuillez reformuler votre question.",
      "safetyFilterBlocked": "Cette requête a été bloquée par les politiques de sécurité. Veuillez reformuler votre question.",
      "unreadableFailure": "Ce rapport d'erreur est illisible : il n'a pas la forme définie par la plateforme. Commencez une nouvelle conversation et, si cela se reproduit, signalez-le à l'administration de la plateforme."
    },
    "attachment": {
      "addAttachment": "Ajouter une pièce jointe",
      "addAttachmentDescription": "Choisissez comment joindre du contenu à votre message",
      "invalidImageFormat": "Format d'image invalide. Autorisés : JPEG, PNG, WebP",
      "invalidPdfFormat": "Veuillez sélectionner un fichier PDF.",
      "processingFailed": "Échec du traitement de l'image",
      "removeDocument": "Retirer le document",
      "removeImage": "Retirer l'image",
      "selectDocument": "Sélectionner un document",
      "selectImage": "Sélectionner une image",
      "takePhoto": "Prendre une photo",
      "uploadDocument": "Téléverser un document",
      "uploadDocumentDescription": "Ouvrir le PDF dans la discussion documentaire"
    },
    "medication": {
      "capture": "Photographier le médicament",
      "defaultQuestion": "Quel est ce médicament ?",
      "imageAlt": "Image du médicament",
      "placeholder": "Question sur le médicament..."
    },
    "scrollToBottom": "Aller au plus récent",
    "scrollToLatest": "Plus récent",
    "turnFailed": "Impossible de terminer cette réponse. Veuillez renvoyer votre message.",
    "turnFailedQuota": "La plateforme a épuisé ses requêtes d'IA pour cette minute : le quota par minute du fournisseur du modèle est partagé par tous les utilisateurs de la plateforme. Attendez une minute, puis renvoyez votre message. Si cela se reproduit souvent, demandez à un administrateur de demander un quota plus élevé.",
    "degradedServices": "Résultats limités – certains services de référence sont temporairement indisponibles",
    "uiResourceDropped": "Une carte de ressource a été omise car le serveur a renvoyé une réponse trop volumineuse.",
    "confirmation": {
      "title": "Confirmation requise"
    },
    "delegation": {
      "askedBy": "Demandé par {{agent}}",
      "answeredBy": "Réponse de {{agent}}",
      "openConsult": "Ouvrir la consultation",
      "couldNotAnswer": "{{agent}} n'a pas pu répondre",
      "seeConsult": "Ouvrez la consultation pour voir où elle s'est arrêtée."
    },
    "handoff": {
      "genericAgent": "Spécialiste"
    },
    "conversation": "Conversation"
  },
  "session": {
    "returnToParent": {
      "label": "Retour à la session"
    },
    "shared": "Partagé",
    "byAuthor": "par {{name}}",
    "newConversation": "Nouvelle conversation",
    "patientFrame": {
      "clear": "Retirer le patient",
      "personal": "Conversation personnelle",
      "shiftsError": "Impossible de charger les patients du service."
    },
    "empty": "Posez votre première question pour commencer la conversation.",
    "loadError": "Impossible de charger la session.",
    "createError": "Impossible de créer la session.",
    "gate": {
      "agentAccessRequired": "Vous n'avez pas accès à cet assistant. Demandez à un administrateur de vous l'attribuer, à vous ou à votre rôle.",
      "patientAccessLapsed": "Vous n'avez plus accès à ce patient : aucune conversation ne peut être ouverte à son sujet. S'il est toujours sous votre responsabilité, demandez à votre responsable d'unité de vous l'attribuer à nouveau."
    },
    "renameError": "Échec du renommage.",
    "deleteError": "Échec de la suppression.",
    "deleteForbidden": "Vous n'avez pas l'autorisation de supprimer cette session.",
    "deleteConnection": "Serveur injoignable. Veuillez réessayer.",
    "archiveError": "Échec de l'archivage.",
    "rename": "Renommer",
    "renameTitle": "Renommer la session",
    "renamePlaceholder": "Nouveau nom...",
    "delete": {
      "title": "Supprimer la session ?",
      "confirm": "Cette session et tous les messages seront définitivement supprimés."
    },
    "topics": "Sujets",
    "hideTopics": "Masquer les sujets",
    "sharing": {
      "sharedWithYou": "{{name}} a partagé une session avec vous",
      "shareError": "Impossible de partager la session. Veuillez réessayer."
    },
    "archive": "Archiver",
    "archiveConfirm": "La conversation sera masquée mais conservée pour votre profil.",
    "archiveTitle": "Archiver la conversation ?",
    "share": "Partager la conversation",
    "notFound": "Conversation introuvable"
  },
  "promptInspector": {
    "trigger": "Que sait l'assistant ?",
    "title": "Instructions de l'assistant",
    "explainer": "Ce sont les instructions que l'assistant suit dans cette conversation.",
    "dynamic": "En direct — reconstruites avec le contexte actuel à chaque message",
    "hash": "id {{hash}}",
    "loadError": "Impossible de charger les instructions.",
    "copy": "Copier",
    "copied": "Copié",
    "confidential": "Possiblement confidentiel",
    "sensitiveNote": "Peut contenir un contexte patient — à traiter comme confidentiel.",
    "layers": {
      "base": "Règles de plateforme et de sécurité",
      "role": "Votre rôle et votre périmètre",
      "session": "Contexte de la session",
      "deployment": "Règles de l'hôpital",
      "patientContext": "Contexte patient",
      "patientSessions": "Conversations du patient"
    }
  },
  "source": {
    "pageRange": "Pages {{start}}-{{end}}",
    "viewOriginal": "Voir le document original",
    "viewSource": "Voir la source"
  },
  "bookmark": {
    "enrichmentRetrying": "Nouvelle tentative...",
    "enrichmentRetryingDetail": "Nouvelle recherche documentaire en cours",
    "enriching": "Enrichissement",
    "enrichmentFailed": "Échec de l'enrichissement",
    "enrichingDetail": "Enrichissement du favori...",
    "enrichingSubtitle": "Recherche dans PubMed et les bases de données médicales",
    "enrichmentRetryHint": "Cliquez sur réessayer",
    "studyTitle": "Signet d'étude",
    "viewChat": "Voir le chat",
    "savedContent": "Contenu enregistré",
    "originalSources": "Sources originales",
    "aiStudySummary": "Résumé d'étude IA",
    "pubmedLiterature": "Littérature PubMed",
    "medicationInfo": "Informations sur les médicaments",
    "noReferences": "Aucune référence supplémentaire trouvée pour ce sujet.",
    "pages": "Pages",
    "relevance": "Pertinence"
  },
  "search": {
    "placeholder": "Rechercher dans les sessions...",
    "noResults": "Aucun résultat trouvé"
  },
  "documents": {
    "loadError": "Impossible de charger le document.",
    "list": {
      "title": "Base de connaissances",
      "upload": "Téléverser",
      "empty": {
        "title": "Aucun document"
      },
      "backHome": "Retour à l'accueil",
      "table": {
        "title": "Titre",
        "category": "Catégorie",
        "status": "Statut",
        "uploaded": "Téléversé",
        "chunks": "Fragments",
        "actions": "Actions",
        "visibility": "Visibilité"
      },
      "delete": {
        "button": "Supprimer",
        "confirm": "Supprimer définitivement ?",
        "confirmButton": "Confirmer",
        "cancel": "Annuler",
        "deleting": "Suppression...",
        "cannotDeleteProcessing": "Suppression impossible pendant le traitement"
      },
      "pagination": "{{shown}} sur {{total}} documents affichés",
      "status": {
        "processing": "En traitement",
        "ready": "Prêt",
        "error": "Erreur",
        "partial_error": "Erreur partielle",
        "quarantined": "En quarantaine",
        "pending_approval": "En attente d'approbation",
        "superseded": "Remplacé",
        "unknown": "Inconnu",
        "partialErrorAction": "Traitement incomplet — peut ne pas apparaître dans la recherche de protocoles. Utilisez « Réessayer » pour relancer le traitement."
      },
      "category": {
        "guideline": "Directive",
        "protocol": "Protocole",
        "procedure": "Procédure",
        "policy": "Politique",
        "standard": "Standard de soins",
        "article": "Article",
        "reference": "Référence",
        "unknown": "Inconnu"
      },
      "date": {
        "today": "Aujourd'hui",
        "yesterday": "Hier",
        "daysAgo": "il y a {{count}} jours"
      },
      "loadMore": "Charger plus",
      "visibility": {
        "private": "Privé",
        "organisation": "Organisation",
        "changeError": "Impossible de modifier la visibilité. Veuillez réessayer.",
        "pendingApproval": "{{name}} — approbation en attente",
        "sentForApproval": "Envoyé pour approbation à {{names}}",
        "sharedWithYou": "Partagé avec vous"
      },
      "search": "Rechercher un document...",
      "retry": {
        "title": "Relancer le traitement",
        "success": "Relance démarrée.",
        "error": "Impossible de relancer le traitement. Veuillez réessayer.",
        "invalidState": "Ce document ne peut plus être relancé."
      },
      "bulk": {
        "selected": "{{count}} sélectionné(s)",
        "selectAll": "Tout sélectionner",
        "selectRow": "Sélectionner {{title}}",
        "makeOrganisation": "Rendre accessible à l'organisation",
        "makePrivate": "Rendre privé",
        "retry": "Réessayer",
        "delete": "Supprimer",
        "clear": "Effacer la sélection",
        "working": "En cours…",
        "confirmDelete": "Supprimer {{count}} document(s) ? Cette action est irréversible.",
        "visibilityDone": "{{count}} document(s) mis à jour.",
        "visibilityPartial": "{{done}} mis à jour, {{failed}} en échec.",
        "deleteDone": "{{count}} document(s) supprimé(s).",
        "deletePartial": "{{done}} supprimé(s), {{failed}} en échec.",
        "retryDone": "Relance démarrée pour {{count}} document(s).",
        "retryPartial": "Relance démarrée pour {{done}}, {{failed}} en échec.",
        "noRetryable": "Aucun des documents sélectionnés ne peut être relancé.",
        "sentForApproval": "{{count}} envoyé(s) pour approbation.",
        "error": "L'action groupée n'a pas pu être terminée. Veuillez réessayer."
      },
      "byOwner": "par {{name}}",
      "searching": "Recherche…",
      "searchEmpty": "Aucun résultat. Les documents en cours de traitement n'apparaissent pas encore dans la recherche.",
      "extractsHeading": "Déclarations clés",
      "extractPage": "p. {{page}}",
      "extractFromFigure": "issu d'une figure",
      "unreadableSource": "{{title}} : la/les page(s) {{pages}} n'ont pas pu être lues — à vérifier directement dans le document source.",
      "extractKind": {
        "dose": "Dose",
        "unknown": "Inconnu"
      },
      "share": "Partager le document"
    },
    "approvals": {
      "approve": "Approuver",
      "reject": "Rejeter",
      "quorumPending": "Approbation enregistrée — {{approvals}} sur {{quorum}} requises",
      "alreadyDecided": "Cette demande a déjà été traitée.",
      "decideError": "Impossible d'enregistrer la décision. Veuillez réessayer.",
      "loadError": "Impossible de charger les approbations en attente.",
      "approved": "Approuvé — la modification est maintenant active.",
      "rejected": "Demande rejetée.",
      "hasMore": "D'autres demandes en attente — décidez celles-ci pour charger la suite.",
      "accessGranted": "Accès accordé.",
      "accessDenied": "Demande refusée.",
      "deny": "Refuser",
      "label": {
        "grantToUser": "{{name}} demande un accès {{level}}",
        "grantToGroup": "Partager {{title}} avec {{grantee}}",
        "publish": "Publier {{title}} pour toute l’organisation"
      },
      "signoffsRecorded": "{{count}} approbation(s) enregistrée(s) à ce jour"
    },
    "sharing": {
      "addTargets": "Partager avec",
      "target": {
        "people": "Personnes",
        "roles": "Rôles",
        "units": "Unités"
      },
      "kind": {
        "person": "Personne",
        "role": "Rôle",
        "unit": "Unité"
      },
      "role": {
        "viewer": "Lecteur",
        "editor": "Éditeur",
        "owner": "Propriétaire",
        "demographics": "Données démographiques"
      },
      "withAccess": "Qui a accès",
      "sentForApproval": "Envoyé pour approbation — sera examiné par {{names}}",
      "sentForApprovalWillAppear": "Envoyé pour approbation — le partage apparaîtra dans la liste après examen par {{names}}",
      "selectRole": "Sélectionner un rôle",
      "selectUnit": "Sélectionner une unité",
      "rolesLoadError": "Impossible de charger les rôles",
      "unitsLoadError": "Impossible de charger les unités",
      "noRoles": "Aucun rôle disponible",
      "noUnits": "Aucune unité disponible",
      "error": {
        "roleRequired": "Sélectionner un rôle",
        "unitRequired": "Sélectionner une unité"
      },
      "visibility": "Visibilité",
      "pendingError": "Impossible de charger les approbations en attente."
    },
    "tabs": {
      "documents": "Documents",
      "approvals": "Approbations"
    },
    "detail": {
      "backToList": "Retour aux documents",
      "title": "Document",
      "openSource": "Ouvrir la source",
      "download": "Télécharger",
      "notReady": "Fichier disponible une fois le traitement terminé.",
      "metadata": "Métadonnées",
      "filename": "Nom du fichier",
      "mimeType": "MIME",
      "sourceType": "Type de source",
      "sourceId": "Source",
      "chunkCount": "Segments",
      "createdAt": "Créé",
      "updatedAt": "Mis à jour",
      "scopeTarget": "Cible de visibilité",
      "owner": "Propriétaire",
      "versions": "Versions",
      "versionsEmpty": "Aucun historique de version enregistré pour ce document.",
      "versionsUnavailable": "L'historique des versions n'a pas pu être chargé.",
      "versionNo": "v{{no}}"
    },
    "upload": {
      "acceptedTypes": "Types acceptés",
      "backToList": "Retour aux documents",
      "categoryLabel": "Catégorie",
      "departmentEmpty": "Aucun service disponible",
      "departmentLabel": "Service",
      "departmentLoadError": "Impossible de charger les services. Touchez pour réessayer.",
      "departmentLoading": "Chargement des services…",
      "departmentNote": "Les documents partagés nécessitent l'approbation d'un administrateur avant d'apparaître dans la recherche",
      "departmentPlaceholder": "Sélectionner un service",
      "error": {
        "departmentRequired": "Veuillez sélectionner un service",
        "invalidTitle": "Le titre contient des caractères invalides. Veuillez supprimer : < > \"",
        "selectFile": "Veuillez sélectionner un fichier et saisir un titre",
        "unsupportedType": "Type de fichier non pris en charge. Veuillez téléverser {{types}}",
        "uploadFailed": "Échec du téléversement",
        "urlRequired": "Veuillez saisir une URL",
        "httpsOnly": "Seules les URL HTTPS sont prises en charge",
        "invalidUrl": "Veuillez saisir une URL valide (p. ex. https://pmc.ncbi.nlm.nih.gov/articles/PMC...)"
      },
      "fileLabel": "Fichier",
      "scopeLabel": "Portée",
      "scopePrivate": "Privé (moi uniquement)",
      "scopeDepartment": "Service",
      "scopePublic": "Toute l'organisation",
      "selected": "Sélectionné : {{name}} ({{size}} Ko)",
      "success": {
        "chunksProcessed": "{{count}} segments traités",
        "pendingApprovalNotice": "Votre document est en attente d'approbation par un administrateur. Il sera consultable après approbation.",
        "statusLabel": "Statut :",
        "title": "Téléversement terminé",
        "uploadAnother": "Téléverser un autre",
        "viewDocuments": "Voir les documents"
      },
      "title": "Téléverser un document",
      "titleLabel": "Titre",
      "titlePlaceholder": "p. ex. Protocole de traitement du sepsis 2024",
      "uploadButton": "Téléverser le document",
      "uploading": "Téléversement...",
      "modeFile": "Fichier",
      "modeURL": "URL",
      "urlHint": "PubMed, PMC ou toute page web",
      "urlLabel": "URL",
      "urlPlaceholder": "https://pmc.ncbi.nlm.nih.gov/articles/PMC...",
      "categoryFallback": "Recommandation"
    }
  },
  "errors": {
    "notFound": "Page non trouvée",
    "accessDenied": "Vous n'avez pas accès à cette ressource ou elle n'existe plus. Essayez de vous connecter avec un autre compte ou contactez le propriétaire de la ressource.",
    "resourceNotFound": "Cette ressource n'est plus disponible.",
    "connection": "Serveur injoignable. Veuillez vérifier votre connexion et réessayer.",
    "serverFault": "Une erreur est survenue de notre côté. Veuillez réessayer.",
    "configLoadFailed": "La configuration n'a pas pu être chargée.",
    "backendUnreachable": "Erreur: Backend inaccessible",
    "unexpectedError": "Une erreur inattendue s'est produite. Veuillez recharger la page.",
    "reloadPage": "Recharger la page",
    "goHome": "Aller à l'accueil"
  },
  "health": {
    "checking": "Vérification de la connexion...",
    "connecting": "Connexion au serveur...",
    "starting": "Démarrage du serveur...",
    "initializing": "Initialisation de l'app...",
    "ready": "Prêt",
    "offline": "Hors ligne",
    "online": "En ligne",
    "unknown": "Inconnu",
    "connected": "Connecté",
    "disconnected": "Serveur indisponible",
    "retrying": "Nouvelle tentative de connexion..."
  },
  "sse": {
    "liveUpdatesDisabled": "Mises à jour en direct indisponibles. Touchez pour recharger.",
    "schemaOutOfDate": "Les mises à jour en direct sont indisponibles car cette version de l'application est obsolète. Veuillez recharger."
  },
  "confidence": {
    "high": "Sources vérifiées",
    "low": "Vérifier les informations",
    "medium": "Infos sur les sources",
    "showReasoning": "Afficher le détail des sources",
    "sourceCount": "{{count}} source",
    "sourceCount_other": "{{count}} sources",
    "justify": "Pourquoi ce niveau de confiance ?",
    "justifyPrompt": "Veuillez justifier votre niveau de confiance pour cette réponse.",
    "topScore": "Meilleure correspondance"
  },
  "carePlan": {
    "title": "Plan de soins",
    "homeTitle": "Plans de soins",
    "patientLabelAria": "Patient",
    "version": "Version {{version}}",
    "copyLink": "Copier le lien",
    "linkCopied": "Copié",
    "daySelector": "Jour",
    "addIntervention": "Ajouter une intervention",
    "interventionDetails": "Détails de l'intervention",
    "nothingPlanned": "Rien de prévu",
    "unassigned": "Non attribué",
    "durationMinutes": "{{minutes}} min",
    "fieldDay": "Jour",
    "fieldTime": "Heure",
    "fieldDuration": "Minutes",
    "fieldTitle": "Ce qui est prévu",
    "fieldTitlePlaceholder": "Titre bref…",
    "fieldAssignee": "Réalisé par",
    "saving": "Enregistrement…",
    "retime": "Déplacer",
    "remove": "Retirer",
    "noDisciplines": "Cette organisation n'a pas encore de rôles cliniques.",
    "noDisciplinesHint": "Un plan de soins se planifie par discipline, et une discipline est un rôle de l'organisation. Demandez à un administrateur de les créer.",
    "conflictRemoved": "Quelqu'un d'autre a retiré cette intervention. Le tableau affiche maintenant le plan actuel.",
    "commandFailed": "La modification n'a pas été enregistrée. Veuillez réessayer.",
    "addIncomplete": "Donnez à l'intervention un titre, une heure et une durée.",
    "retimeIncomplete": "Donnez à l'intervention une heure et une durée.",
    "readFailed": "Ce plan de soins n'a pas pu être lu.",
    "chatPlaceholder": "Donnez des instructions à l'agent…",
    "caseloadFailed": "La liste des patients n'a pas pu être lue.",
    "emptyCaseload": "Aucun patient n'est admis.",
    "emptyCaseloadHint": "Un plan de soins appartient à un séjour. Admettez un patient pour planifier sa semaine.",
    "conversationUnresolved": "Cette conversation n'a pas pu être ouverte.",
    "conversationHasNoStay": "Cette conversation ne concerne pas un patient admis, il n'y a donc pas de plan de soins à ouvrir.",
    "faceNeedsPatient": "Un plan de soins appartient à un patient. Ouvrez-le depuis l'unité.",
    "stayUnresolved": "Le séjour de ce patient n'a pas pu être lu.",
    "patientNotAdmitted": "Ce patient n'est pas admis, il n'y a donc pas de séjour à planifier.",
    "executionInProgress": "En cours",
    "executionCompleted": "Fait",
    "executionCancelled": "Annulé",
    "executionMissed": "Non réalisé",
    "executionUnavailable": "Ce qui a déjà été fait n'a pas pu être lu ; cette semaine n'affiche que le plan."
  },
  "roster": {
    "homeTitle": "Planning des équipes",
    "newRoster": "Nouveau planning",
    "untitled": "Planning sans titre",
    "emptyHomeTitle": "Aucun planning",
    "emptyTitle": "Aucun service",
    "nurseColumn": "Soignant·e",
    "daySelector": "Jour",
    "offDuty": "Repos",
    "share": "Partager",
    "shareFallbackTitle": "Planning des services",
    "sharedByViewOnly": "Partagé par {{author}} · lecture seule",
    "viewOnly": "Lecture seule",
    "emptyViewerHint": "Le ou la responsable n’a pas encore ajouté de services.",
    "myRosters": "Mes plannings",
    "sharedWithMe": "Partagés avec moi",
    "sharedChip": "Partagé",
    "byAuthor": "par {{author}}",
    "editFailed": "Impossible d’enregistrer la modification. Veuillez réessayer.",
    "optimizing": "Troi optimise…",
    "load_one": "{{count}} service",
    "load_other": "{{count}} services",
    "group": {
      "other": "Autres"
    },
    "team": {
      "none": "Aucun membre d’équipe pour cette unité.",
      "loadError": "Impossible de charger l’équipe de l’unité."
    },
    "horizon": {
      "week": "Semaine",
      "twoWeeks": "2 semaines",
      "month": "Mois",
      "prev": "Période précédente",
      "next": "Période suivante",
      "days": "{{count}} jours"
    },
    "status": {
      "updating": "mise à jour…",
      "occurrencesUnavailable": "Les noms des services et ce qui a été travaillé n'ont pas pu être lus ; les cellules n'affichent que leur code"
    },
    "cell": {
      "change": "Modifier le service de {{nurse}}"
    },
    "picker": {
      "clear": "Effacer (repos)"
    },
    "empty": {
      "scope": "{{count}} jours · {{range}}",
      "create": "Créer le planning"
    },
    "troi": {
      "title": "Demander à Troi",
      "open": "Demander à Troi",
      "hint": "Décrivez une modification en mots — p. ex. « donne le week-end à Anna ». Troi l’applique au tableau.",
      "placeholder": "Demandez à Troi d’ajuster le planning…"
    }
  },
  "triples": {
    "relatedResources": "Ressources associées",
    "openProtocol": "Ouvrir le protocole",
    "startProtocol": "Démarrer le protocole",
    "notYetWired": "Pas encore connecté",
    "notYetWiredToast": "Cette ressource n'est pas encore connectée.",
    "unavailable": "Ressources associées indisponibles",
    "unavailableHint": "Impossible de charger les ressources associées pour cette réponse. Veuillez réessayer dans un instant.",
    "runner": {
      "description": "Parcourir le protocole étape par étape",
      "loadFailed": "Impossible de charger le protocole.",
      "stepFailed": "Impossible d'avancer dans le protocole.",
      "retry": "Réessayer",
      "done": "Terminé",
      "backToStart": "Retour au début",
      "errorCodes": {
        "protocolRunFailed": "Échec de l'exécution du protocole",
        "protocolRunInternal": "Erreur interne d'exécution du protocole"
      }
    }
  },
  "compatibility": {
    "homeTitle": "Compatibilité Y-site",
    "subtitle": "Verdict Y-site",
    "loading": "Chargement de la matrice …",
    "parseError": "Le résultat de compatibilité n'a pas pu être lu.",
    "newCheck": "Nouvelle vérification",
    "untitled": "Vérification sans titre",
    "emptyHomeTitle": "Aucune vérification pour l'instant",
    "emptyHomeDescription": "Ouvrez la matrice Y-site pour vérifier si deux médicaments peuvent être co-perfusés",
    "datasetLabel": "Jeu de données",
    "pairsCount": "{{count}} paires",
    "validUntil": "valable jusqu'au",
    "search": {
      "placeholder": "Rechercher un médicament — nom, ATC, SNOMED …",
      "clear": "Effacer la recherche",
      "noResults": "Aucun médicament ne correspond à « {{query}} ».",
      "offMatrix": "Recherche de « {{query}} » dans les données médicamenteuses suisses."
    },
    "legend": {
      "title": "Légende",
      "ok": "Compatible",
      "warn": "Rincer",
      "bad": "Incompatible",
      "muted": "Aucune donnée"
    },
    "toneFilter": {
      "groupLabel": "Afficher les tons de verdict",
      "toggleOn": "Masquer les cellules « {{tone}} »",
      "toggleOff": "Afficher les cellules « {{tone}} »",
      "showAll": "Tout afficher",
      "allHidden": "Tous les tons sont masqués — touchez une puce de la légende pour les afficher."
    },
    "tabs": {
      "aria": "Vues de compatibilité",
      "matrix": "Matrice",
      "carriers": "Solutions porteuses",
      "separate": "Administration séparée"
    },
    "matrix": {
      "title": "Matrice de compatibilité",
      "self": "Même médicament",
      "noData": "Aucune donnée",
      "ariaCell": "{{a}} avec {{b}} : {{verdict}}"
    },
    "carriers": {
      "title": "Compatibilité avec les solutions porteuses",
      "empty": "Aucune donnée de compatibilité avec les solutions porteuses dans cette matrice.",
      "noEntry": "Aucune entrée"
    },
    "separate": {
      "title": "Médicaments à administrer séparément",
      "emptyTitle": "Aucun médicament dans cette matrice ne nécessite une administration séparée.",
      "selectAria": "{{drug}} — {{verdict}}"
    },
    "verdicts": {
      "compatible_same_lumen": "Compatible — co-administrer par une seule lumière",
      "compatible_with_all_carriers": "Compatible avec toutes les solutions porteuses standards",
      "requires_line_flush": "Rincer la ligne entre les médicaments",
      "incompatible": "Incompatible — ne pas co-administrer",
      "no_data": "Aucune donnée"
    },
    "derivedNote": "Verdict dérivé — non directement vérifié dans la matrice source.",
    "selfPairNote": "Même médicament sur les deux axes — l'auto-mélange Y-site n'a pas de sens.",
    "panel": {
      "verdictTitle": "Verdict Y-site",
      "atc": "ATC",
      "emptyTitle": "Sélectionnez un médicament",
      "emptyHint": "Touchez une case pour un verdict Y-site, ou un nom de médicament pour l'aperçu.",
      "close": "Masquer le panneau de détails",
      "expand": "Afficher le panneau de détails",
      "overlayTitle": "Détails du médicament",
      "resizeHandle": "Redimensionner le panneau de détails",
      "drugInfoTitle": "Information sur le médicament"
    },
    "medication": {
      "loading": "Chargement des données médicamenteuses…",
      "error": "Impossible de charger les données médicamenteuses. Modifiez la recherche pour réessayer.",
      "notFound": "Introuvable dans toute base de données médicamenteuse.",
      "ingredients": "Principes actifs",
      "fachinfo": "Information professionnelle",
      "showMore": "Afficher les informations complètes ({{count}})",
      "showLess": "Afficher moins",
      "sourceLabel": "Source : {{source}}",
      "tier": {
        "internal": "Liste des médicaments de l’hôpital",
        "national": "Swissmedic (SAI)",
        "international": "NHS dm+d (RU)"
      }
    },
    "pairPicker": {
      "slotA": "Médicament A",
      "slotB": "Médicament B",
      "pick": "Choisir {{slot}}",
      "pickShort": "Choisir un médicament",
      "change": "Changer {{slot}}",
      "clear": "Effacer {{slot}}",
      "prompt": "Choisissez deux médicaments pour voir le verdict Y-site.",
      "noResults": "Aucun médicament ne correspond à la recherche."
    },
    "notice": {
      "noData": "Aucune donnée — vérification humaine nécessaire",
      "institution_not_registered": "Institution non enregistrée pour les vérifications de compatibilité.",
      "drug_not_recognized": "Le médicament n'a pas été reconnu.",
      "pair_not_in_matrix": "Cette association n'est pas dans la matrice de cette institution."
    }
  },
  "patients": {
    "title": "Patients",
    "attributes": {
      "pattern_hint": "Format : {{pattern}}",
      "ward": "Unité",
      "bed": "Lit",
      "room": "Chambre",
      "unit": "Service",
      "admission_ref": "Réf. d'admission",
      "age": "Âge",
      "glasgow": "Score de Glasgow",
      "mobility": "Mobilité",
      "main_diagnosis": "Diagnostic principal",
      "resuscitation_status": "Statut de réanimation",
      "coding_status": "Statut de codage"
    },
    "register": {
      "title": "Enregistrer un patient",
      "labelPreview": "Aperçu",
      "wardLoadError": "Impossible de charger la liste des unités — saisir le service.",
      "wardPlaceholder": "Sélectionner une unité",
      "submit": "Enregistrer",
      "submitting": "Enregistrement...",
      "configUnavailable": "Chargement de la configuration...",
      "error": "Impossible d'enregistrer le patient.",
      "admissionLink": {
        "title": "Lien d'admission",
        "explanation": "L'identifiant réel de l'admission pour cette unité. Sert à lier ce patient à son dossier SIH — n'est plus affiché après l'enregistrement, sauf via une consultation auditée.",
        "tokenLabel": "Référence d'admission",
        "tokenExplanation": "Cette référence est désormais le repère d'admission visible du patient. Notez-la si nécessaire — elle ne sera plus réaffichée ici.",
        "continue": "Continuer"
      },
      "needAnyAttribute": "Saisissez au moins une information permettant d'identifier le patient.",
      "justRegistered": "{{patient}} enregistré",
      "batchCount_one": "{{count}} enregistré",
      "batchCount_other": "{{count}} enregistrés",
      "moreFields": "Autres informations",
      "done": "Terminé",
      "submitNext": "Enregistrer le suivant",
      "save": "Enregistrer",
      "staleWrite": "Une autre personne a modifié ce patient pendant votre saisie. Le formulaire affiche maintenant les données enregistrées — appliquez votre modification à nouveau puis enregistrez.",
      "revisionUnavailable": "La version actuelle de cet enregistrement n’a pas pu être lue, il ne peut donc pas encore être enregistré.",
      "schemaUnavailable": "Les champs de l’unité de ce patient n’ont pas pu être chargés.",
      "pickUnitFirst": "Sélectionnez une unité pour voir les champs qu’elle enregistre."
    },
    "admissionLink": {
      "fields": {
        "case_number": "Numéro de cas (SIH)"
      }
    },
    "list": {
      "stale": "Mise à jour...",
      "empty": {
        "title": "Aucun patient pour l'instant",
        "description": "Enregistrez un patient pour commencer."
      },
      "loadError": {
        "title": "Impossible de charger la liste.",
        "retry": "Réessayer"
      }
    },
    "assign": {
      "title": "Attribuer à un patient",
      "action": "Attribuer à un patient",
      "current": "Attribution actuelle",
      "choose": "Choisir un patient",
      "unassign": "Retirer l'attribution",
      "unknownPatient": "Patient inconnu",
      "error": "Impossible d'attribuer la session."
    },
    "unassign": {
      "error": "Impossible de retirer l'attribution."
    }
  },
  "patientAdmin": {
    "homeTitle": "Administration des patients",
    "subtitle": "Recensement du service",
    "list": {
      "title": "Patients",
      "addNew": "Enregistrer un nouveau patient",
      "loadError": {
        "title": "Impossible de charger les patients.",
        "retry": "Réessayer"
      },
      "empty": {
        "title": "Aucun patient pour l'instant",
        "description": "Enregistrez un patient pour commencer."
      },
      "showDischarged": "Afficher les patients sortis"
    },
    "detail": {
      "selectPrompt": "Sélectionnez un patient pour voir son séjour.",
      "currentPlacement": "Placement actuel",
      "unit": "Unité",
      "noActiveStay": "Actuellement non admis",
      "stayHistory": "Historique des séjours",
      "stale": "Mise à jour...",
      "noHistory": "Aucun séjour enregistré pour l'instant.",
      "noHistoryDescription": "Les admissions et transferts apparaîtront ici.",
      "loadError": {
        "title": "Impossible de charger l'historique des séjours.",
        "retry": "Réessayer"
      },
      "class": "Classe",
      "status": "Statut",
      "attributesTitle": "Attributs",
      "awaitingCaseNumber": "Sans numéro de cas",
      "noAttributes": "Aucun attribut enregistré.",
      "codenameExplanation": "Pseudonyme généré automatiquement à partir de la référence du patient — aucun nom n'est stocké.",
      "admittedAt": "Admis",
      "dischargedAt": "Sorti",
      "disposition": "Mode de sortie",
      "dispositionsUnavailable": "Les modes de sortie ne sont pas disponibles pour le moment. Veuillez réessayer sous peu.",
      "responsibleService": "Service responsable",
      "timeline": "Événements de placement",
      "admittedToday": "admis aujourd'hui ({{at}})",
      "admittedSince_one": "admis depuis 1 jour ({{at}})",
      "admittedSince_other": "admis depuis {{count}} jours ({{at}})",
      "notInList": "Ce patient ne figure pas dans la liste actuelle",
      "notInListDescription": "Il a peut-être été sorti — activez « Afficher les sorties »."
    },
    "overview": {
      "totalPatients": "Patients enregistrés",
      "otherWards": "+{{count}} de plus",
      "unavailable": "Recensement indisponible pour le moment"
    },
    "actions": {
      "admit": "Admettre",
      "transfer": "Transférer",
      "discharge": "Sortir",
      "cancel": "Annuler",
      "editAttributes": "Modifier les attributs",
      "continue": "Continuer",
      "confirmAdmit": "Admettre dans l'unité",
      "confirmTransfer": "Transférer vers l'unité",
      "confirmTransferPrompt": "Transférer {{patient}} vers {{unit}} ?",
      "confirmDischarge": "Sortir le patient",
      "confirmDischargePrompt": "Sortir {{patient}} — {{disposition}} ?",
      "chooseUnit": "Choisir une unité",
      "chooseDisposition": "Choisir un mode de sortie",
      "submitting": "Enregistrement…"
    },
    "admissionRef": {
      "title": "Lien d'admission",
      "loadError": "Impossible de charger le statut de liaison.",
      "unlinkedHint": "Cette référence d'admission n'est pas encore liée à un dossier SIH.",
      "linkedHint": "Liée à un dossier SIH.",
      "linkNow": "Lier maintenant",
      "reveal": "Consulter le lien d'admission",
      "linkTitle": "Lier la référence d'admission",
      "linkExplanation": "Saisissez l'identifiant réel de l'admission pour cette unité. Cela lie la référence d'admission du patient à son dossier SIH.",
      "linkSubmit": "Enregistrer le lien",
      "linkError": "Impossible d'enregistrer le lien d'admission. Veuillez réessayer.",
      "revealTitle": "Consulter le lien d'admission",
      "revealDescription": "La consultation de ce lien est enregistrée dans le journal d'audit.",
      "reasonLabel": "Motif de l'accès",
      "reasonPlaceholder": "Sélectionner un motif",
      "reasonsUnavailable": "Les motifs de consultation ne sont pas disponibles pour le moment. Veuillez réessayer sous peu.",
      "reasons": {
        "care_handover": "Transmission de soins",
        "billing_query": "Demande de facturation",
        "kis_reconciliation": "Rapprochement SIH",
        "other": "Autre"
      },
      "invalidReasonCode": "Choisissez un motif valide.",
      "justificationLabel": "Justification",
      "justificationPlaceholder": "Pourquoi vous avez besoin d'accéder maintenant",
      "notFound": "Ce lien d'admission n'est pas disponible.",
      "revealFailed": "Impossible de consulter le lien d'admission. Veuillez réessayer.",
      "confirm": "Consulter",
      "revealing": "Consultation…",
      "resultTitle": "Lien d'admission",
      "resultWarning": "Ces informations ne sont affichées qu'une seule fois et ne sont pas conservées dans cette session.",
      "done": "Terminé"
    },
    "class": {
      "inpatient": "Hospitalisation",
      "emergency": "Urgence",
      "observation": "Observation",
      "outpatient": "Ambulatoire"
    },
    "status": {
      "in_progress": "En cours",
      "discharged": "Sorti",
      "cancelled": "Annulé",
      "not_admitted": "Non admis"
    },
    "disposition": {
      "home": "Domicile",
      "transfer": "Transféré",
      "deceased": "Décédé",
      "against_advice": "Contre avis médical"
    },
    "eventType": {
      "admit": "Admis",
      "transfer": "Transféré",
      "discharge": "Sorti",
      "cancel_admit": "Admission annulée",
      "cancel_transfer": "Transfert annulé",
      "cancel_discharge": "Sortie annulée"
    },
    "errors": {
      "updateAttributesFailed": "Impossible d'enregistrer les attributs. Veuillez réessayer.",
      "noActiveEncounter": "Ce patient n'a pas de séjour en cours. Admettez-le d'abord.",
      "encounterInProgress": "Ce patient a déjà un séjour en cours.",
      "patientMoved": "Le patient a été déplacé depuis cette demande. Vérifiez son unité actuelle et réessayez.",
      "patientReAdmitted": "Le lieu du patient a changé. Vérifiez son unité actuelle et réessayez.",
      "admitSuperseded": "Le patient est sorti entre-temps. Vérifiez son statut actuel.",
      "placementRequired": "Choisissez une unité pour ce patient.",
      "locationHasChildren": "Cette unité a des sous-unités. Choisissez un service ou un lit précis.",
      "invalidClass": "Choisissez une classe valide.",
      "invalidDisposition": "Choisissez un mode de sortie valide.",
      "admitFailed": "Impossible d'admettre le patient. Veuillez réessayer.",
      "transferFailed": "Impossible de transférer le patient. Veuillez réessayer.",
      "dischargeFailed": "Impossible de faire sortir le patient. Veuillez réessayer."
    },
    "loading": "Chargement…"
  },
  "shifts": {
    "title": "Services",
    "patient": {
      "label": "Patient",
      "placeholder": "Choisir un patient"
    },
    "nurse": {
      "placeholder": "Saisir un nom",
      "unknown": "Inconnu",
      "free": "libre",
      "patientLoad_one": "{{count}} pat.",
      "patientLoad_other": "{{count}} pat."
    },
    "handover": {
      "action": "Transmettre",
      "title": "Transmettre le patient",
      "curation": "Ce qui accompagne le patient",
      "curationHint": "Signalez les conversations que votre collègue doit voir en premier.",
      "noteLabel": "Note de transmission",
      "notePlaceholder": "Ce que votre collègue doit savoir…",
      "start": "Démarrer la transmission",
      "starting": "Démarrage…",
      "startHint": "Votre collègue rejoint le rapport. La responsabilité reste la vôtre jusqu’à la réattribution du patient.",
      "startError": "La transmission n’a pas pu être démarrée.",
      "flaggedIntro": "Signalé pour la transmission :",
      "defaultSeed": "Je transmets ce patient. Merci de préparer un bref rapport.",
      "sessionTitle": "Transmission {{patient}}",
      "picker": {
        "onShift": "En service",
        "loadError": "Impossible de charger qui est en service.",
        "empty": "Aucun·e collègue en service dans votre unité.",
        "searchOther": "Chercher une autre personne"
      }
    },
    "journey": {
      "title": "Votre chemin dans le service",
      "youAreHere": "Vous êtes ici",
      "start": "Commencer le service",
      "takeover": "Prendre en charge les patients",
      "patientCount_one": "{{count}} patient à votre charge",
      "patientCount_other": "{{count}} patients à votre charge",
      "handover": "Transmettre",
      "rapportRunning_one": "Rapport en cours pour {{count}} patient",
      "rapportRunning_other": "Rapport en cours pour {{count}} patients",
      "handoverHint": "Vers la fin de votre service, par patient.",
      "end": "Terminer le service"
    },
    "loadError": "Impossible de charger votre service.",
    "offDuty": {
      "title": "Vous n'êtes pas en service",
      "description": "Commencez votre service pour prendre soin de vos patients."
    },
    "onDuty": {
      "title": "En service",
      "patientCount_one": "{{count}} patient",
      "patientCount_other": "{{count}} patients"
    },
    "myPatients": "Mes patients",
    "noPatients": {
      "title": "Pas encore de patients",
      "description": "Ajoutez un patient pour commencer sa prise en charge."
    },
    "endAssignment": {
      "action": "Terminer",
      "error": "Impossible de terminer l’attribution."
    },
    "addPatient": {
      "title": "Ajouter un patient",
      "submitting": "Ajout…",
      "submit": "Ajouter un patient",
      "none": {
        "title": "Plus de patients à ajouter",
        "description": "Tous les patients enregistrés sont déjà dans votre service."
      }
    },
    "end": {
      "submitting": "Fin en cours…",
      "submit": "Terminer le service",
      "error": "Impossible de terminer le service."
    },
    "assign": {
      "error": "Impossible d’attribuer le patient."
    }
  },
  "sharing": {
    "roleLabel": "Niveau d'accès",
    "searchTruncated": "Affichage de {{shown}} sur {{total}} — affinez votre recherche",
    "searchFailed": "Échec de la recherche. Veuillez réessayer.",
    "error": {
      "lastOwner": "Impossible de retirer le dernier propriétaire. Transférez d'abord la propriété."
    }
  },
  "approvals": {
    "title": "Approbations",
    "backHome": "Retour à l'accueil",
    "empty": "Aucune approbation en attente.",
    "sections": {
      "documents": "Documents",
      "units": "Unités"
    }
  },
  "colleague": {
    "detailsAriaLabel": "Détails de {{name}}",
    "title": "Collègues avec de l'expérience",
    "yearsAbbrev": "{{years}}a"
  },
  "offline": {
    "cacheCount": "{{count}} réponse enregistrée",
    "cacheCount_other": "{{count}} réponses enregistrées",
    "cacheDescription": "Vos 10 dernières questions et réponses, disponibles même sans connexion Internet.",
    "cacheTitle": "Réponses en cache",
    "citationCount": "{{count}} source",
    "citationCount_other": "{{count}} sources",
    "clearCache": "Vider le cache",
    "emptyCache": "Aucune réponse en cache pour le moment",
    "viewCached": "Réponses enregistrées"
  },
  "time": {
    "daysAgo": "{{count}} jour",
    "daysAgo_other": "{{count}} jours",
    "hoursAgo": "{{count}} h",
    "hoursAgo_other": "{{count}} h",
    "justNow": "à l'instant",
    "minutesAgo": "{{count}} min",
    "minutesAgo_other": "{{count}} min"
  },
  "footer": {
    "disclaimer": "Documentation et recherche de directives pour le personnel soignant."
  },
  "feedback": {
    "failedDescription": "Votre commentaire n'a pas pu être enregistré. Veuillez réessayer.",
    "helpful": "Réponse utile",
    "unhelpful": "Réponse inutile",
    "viewBookmark": "Voir le signet",
    "saveBookmark": "Enregistrer comme signet"
  },
  "elicitation": {
    "error": {
      "fieldRequired": "Ce champ est obligatoire.",
      "required": "Veuillez remplir tous les champs obligatoires.",
      "submit": "Échec de l'envoi. Veuillez réessayer.",
      "network": "Erreur réseau. Veuillez réessayer."
    },
    "pleaseSelect": "Veuillez sélectionner…",
    "decline": "Refuser"
  },
  "uiAction": {
    "error": {
      "generic": "L'action a échoué. Veuillez réessayer.",
      "notSent": "L'action n'a pas pu être envoyée"
    },
    "externalLink": {
      "title": "Ouvrir le lien externe ?",
      "body": "Cela ouvrira {{origin}} dans un nouvel onglet."
    }
  },
  "skills": {
    "header": {
      "title": "Mon profil de connaissances"
    },
    "loading": {
      "ariaLabel": "Chargement"
    },
    "error": {
      "loadFailed": "Vos compétences n'ont pas pu être chargées.",
      "unknownError": "Erreur inconnue.",
      "retry": "Réessayer"
    },
    "section": {
      "declare": "Déclarer une compétence",
      "view": "Vue"
    },
    "view": {
      "list": "Liste",
      "map": "Carte des connaissances",
      "switcherAriaLabel": "Choisir une vue"
    },
    "form": {
      "labelPlaceholder": "Avec quoi avez-vous travaillé ? Par exemple la prise en charge du sepsis",
      "labelAriaLabel": "Compétence dans vos propres mots",
      "addButton": "Ajouter",
      "catalogueAriaLabel": "Compétence du catalogue",
      "catalogueNone": "Aucune compétence du catalogue",
      "catalogueLoading": "Chargement du catalogue…",
      "catalogueFailed": "Le catalogue des compétences n'a pas pu être chargé. Vous pouvez toujours déclarer une compétence dans vos propres mots.",
      "catalogueNotConfigured": "Aucun catalogue de compétences n'est défini pour cette installation. Nommez votre compétence dans vos propres mots."
    },
    "proposed": {
      "title": "Proposé par le curateur",
      "empty": "Aucune proposition. Le curateur lit vos sessions — les nouvelles propositions apparaissent ici."
    },
    "proposal": {
      "accept": "Accepter",
      "reject": "Refuser",
      "acceptAriaLabel": "Accepter : {{label}}",
      "rejectAriaLabel": "Refuser : {{label}}",
      "reasoningLoading": "Chargement de la justification…",
      "reasoningFailed": "La justification n'a pas pu être chargée. Chargez-la avant de décider.",
      "reasoningMissing": "Cette proposition ne porte aucune justification."
    },
    "pending": {
      "title": "Ce que vous visez",
      "empty": "Rien que vous visez actuellement.",
      "target": "Objectif pour le {{due}} · {{basis}}",
      "qualificationStarts": "Certificat valable dès le {{date}}",
      "recordsLoading": "Chargement des enregistrements…",
      "recordsFailed": "Les enregistrements correspondants n'ont pas pu être chargés."
    },
    "targetBasis": {
      "declared": "sur votre propre déclaration",
      "qualified": "sur la vérification de l'institution"
    },
    "held": {
      "title": "Mes compétences",
      "empty": "Rien d'enregistré. Déclarez ci-dessus ce avec quoi vous avez travaillé.",
      "publish": "Publier",
      "unpublish": "Retirer",
      "publishAriaLabel": "Publier : {{label}}",
      "unpublishAriaLabel": "Retirer : {{label}}",
      "showEndorsements": "Recommandations de collègues"
    },
    "rejected": {
      "title": "Refusé"
    },
    "basis": {
      "declaration": "Auto-déclaré",
      "endorsement": "Par des collègues",
      "qualification": "Vérifié par l'institution",
      "attempt": "Depuis les modules de formation",
      "proposal": "Proposé",
      "target": "Objectif"
    },
    "badges": {
      "validUntil": "Valable jusqu'au {{date}}"
    },
    "endorsements": {
      "empty": "Aucune recommandation de collègue pour l'instant.",
      "loadFailed": "Les recommandations n'ont pas pu être chargées.",
      "colleague": "Une collègue",
      "noComment": "Recommandé, sans commentaire."
    },
    "map": {
      "clinicalConcepts": "Concepts cliniques",
      "furtherSkills": "Autres compétences",
      "empty": "Rien ici pour l'instant."
    },
    "toast": {
      "saveFailed": "N'a pas pu être enregistré",
      "saveFailedDesc": "Veuillez réessayer.",
      "staleVersion": "Modifié entre-temps",
      "staleVersionDesc": "Cette compétence a changé depuis que vous l'avez ouverte. L'état actuel est affiché."
    }
  },
  "targets": {
    "due": "Pour le {{date}}",
    "overdue": "Échéance dépassée : {{date}}",
    "examDate": "Examen {{date}}",
    "state": {
      "achieved": "Atteint",
      "dropped": "Abandonné"
    }
  },
  "agent": {
    "chat": {
      "name": "Chat"
    },
    "care-planner": {
      "name": "Plan de soins"
    },
    "compatibility": {
      "name": "Compatibilité"
    },
    "protocols": {
      "name": "Analyse de processus"
    },
    "knowledge-profile": {
      "name": "Profil de connaissances"
    },
    "roster": {
      "name": "Planning"
    },
    "patient-admin": {
      "name": "Administration des patients"
    },
    "learn": {
      "name": "Apprentissage"
    },
    "mentor": {
      "name": "Formation"
    },
    "access": {
      "name": "Mon accès"
    },
    "team-access": {
      "name": "Accès de l'équipe"
    },
    "allocation": {
      "name": "Attribution des patients"
    },
    "handover": {
      "name": "Transmission"
    }
  },
  "conversation": {
    "state": {
      "active": "Actif",
      "done": "Terminé",
      "needsReview": "À vérifier"
    }
  },
  "admin": {
    "analytics": {
      "dash": {
        "overview": "Vue d'ensemble",
        "latency": "Latence",
        "usage": "Utilisation",
        "competencies": "Compétences de l'équipe",
        "training": "Formation",
        "loadError": "Échec du chargement du tableau de bord — veuillez réessayer.",
        "slowLoad": "Plus long que d'habitude — le backend d'analyse est peut-être en cours de démarrage."
      }
    },
    "dashboard": {
      "title": "Tableau de bord admin",
      "previewTooltip": "Votre aperçu admin en lecture seule se termine dans {{count}} jour.",
      "previewTooltip_other": "Votre aperçu admin en lecture seule se termine dans {{count}} jours.",
      "previewBadge": "Aperçu admin · {{count}} jour restant",
      "previewBadge_other": "Aperçu admin · {{count}} jours restants",
      "tabs": {
        "queries": "Requêtes",
        "clusters": "Groupes",
        "sessions": "Sessions",
        "feedback": "Retours",
        "reported-errors": "Erreurs signalées",
        "approvals": "Approbations",
        "organisation": "Organisation",
        "permissions": "Autorisations"
      },
      "tabHelp": {
        "queries": "Parcourez tous les journaux de requêtes. Cliquez sur une requête pour voir la session complète avec le prompt système et les appels d'outils.",
        "clusters": "Regroupez les requêtes par période, rôle, expérience ou établissement pour repérer des tendances.",
        "sessions": "Consultez les sessions de chat complètes avec messages, citations, confiance et prompt système.",
        "feedback": "Tous les retours des utilisateurs (pouce haut/bas). Cliquez pour voir le contexte complet de la session.",
        "reported-errors": "Erreurs côté client signalées par les utilisateurs via « Signaler » ou ayant fait planter un écran — la destination de l'action Signaler. Les plus récentes d'abord.",
        "approvals": "Approuvez ou rejetez les documents institutionnels en attente de révision. Les documents sont en quarantaine jusqu'à approbation.",
        "organisation": "Gérez la hiérarchie des emplacements, les rôles, qui travaille où, et quels patients se trouvent dans quelle unité.",
        "permissions": "Accorder ou retirer l'accès aux autorités de la plateforme, à chaque zone admin et à chaque agent — pour une personne ou tout un rôle."
      }
    },
    "queryExplorer": {
      "loadError": "Échec du chargement des requêtes — veuillez réessayer.",
      "searchPlaceholder": "Rechercher des requêtes...",
      "prev": "Préc.",
      "next": "Suiv.",
      "pagePrefix": "p.",
      "citations": "{{count}} citation",
      "citations_other": "{{count}} citations",
      "empty": "Aucune requête trouvée",
      "selectPrompt": "Sélectionnez une requête pour voir la session complète",
      "sessionLoadError": "Échec du chargement de la session",
      "feedbackType": {
        "positive": "positif",
        "negative": "négatif",
        "incorrect": "incorrect",
        "missing": "manquant",
        "other": "autre"
      }
    },
    "userSelect": {
      "searchPlaceholder": "Rechercher des utilisateurs...",
      "clearFilter": "Réinitialiser le filtre utilisateur",
      "clear": "Réinitialiser",
      "loadFailed": "Impossible de charger les utilisateurs.",
      "noResults": "Aucun utilisateur trouvé"
    },
    "feedbackExplorer": {
      "timeRange": {
        "day": "Dernières 24 h",
        "week": "Les 7 derniers jours",
        "month": "Les 30 derniers jours"
      },
      "filter": {
        "all": "Tous",
        "positive": "Positif",
        "negative": "Négatif",
        "incorrect": "Incorrect",
        "missing": "Manquant",
        "other": "Autre"
      },
      "entriesLabel": "retours",
      "positiveCount": "{{count}} positif",
      "negativeCount": "{{count}} négatif",
      "loadError": "Échec du chargement des retours",
      "empty": "Aucun retour pour cette période",
      "noQueryText": "Aucun texte de requête",
      "untitledSession": "Session sans titre",
      "showingEntries": "Affichage de {{shown}} sur {{total}} entrées",
      "selectPrompt": "Sélectionnez un retour pour voir la session complète"
    },
    "queryClusters": {
      "loadError": "Échec du chargement des groupes de requêtes",
      "dimension": {
        "time": "Période",
        "role": "Rôle",
        "experience": "Expérience",
        "specialisation": "Spécialisation",
        "institution": "Établissement"
      },
      "timeRange": {
        "day": "Jour",
        "week": "Semaine",
        "month": "Mois"
      },
      "viewCards": "Cartes",
      "viewChart": "Graphique",
      "empty": "Aucun groupe de requêtes trouvé pour cette dimension",
      "hideExamples": "Masquer les exemples",
      "showExamples": "Afficher {{count}} exemple",
      "showExamples_other": "Afficher {{count}} exemples"
    },
    "documentApproval": {
      "serviceUnavailable": "Le service de connaissances n'est pas disponible dans cet environnement.",
      "serviceUnavailableHint": "Le knowledge-service doit être en cours d'exécution pour l'approbation des documents.",
      "loadError": "Échec du chargement des documents en attente",
      "empty": "Aucun document en attente d'approbation",
      "columnTitle": "Titre",
      "columnCategory": "Catégorie",
      "columnStatus": "Statut",
      "columnUploaded": "Téléversé",
      "columnChunks": "Fragments",
      "columnActions": "Actions",
      "deleteConfirmPrompt": "Supprimer définitivement ?",
      "confirm": "Confirmer",
      "approving": "Approbation...",
      "approve": "Approuver",
      "reject": "Rejeter",
      "showingDocuments": "Affichage de {{shown}} sur {{total}} documents"
    },
    "sessionMonitor": {
      "loadError": "Impossible de charger les sessions",
      "empty": "Aucune session trouvée",
      "selectPrompt": "Sélectionnez une session pour afficher les messages"
    },
    "sessionDetail": {
      "loadErrorTitle": "Impossible de charger cette session",
      "loadErrorBody": "Une erreur est survenue lors du chargement de la session. Veuillez réessayer dans un instant.",
      "selectPrompt": "Sélectionnez une session pour afficher les messages",
      "untitled": "Session sans titre",
      "messageCount": "{{count}} message",
      "messageCount_other": "{{count}} messages",
      "noMessages": "Aucun message dans cette session",
      "toolTracesUnavailable": "Traces d'outils indisponibles",
      "toolCalls": "{{tool}} ×{{calls}}",
      "imageAttached": "Image jointe"
    },
    "reportedErrors": {
      "intro": "Erreurs signalées par les utilisateurs via « Signaler » ou ayant fait planter un écran — les plus récentes d'abord.",
      "refresh": "Actualiser",
      "loadError": "Impossible de charger les erreurs signalées",
      "empty": "Aucune erreur signalée pour l'instant.",
      "reportedBy": "Signalé par {{name}}",
      "reporterUnknown": "Auteur inconnu",
      "componentStack": "Pile de composants",
      "detail": {
        "request": "Appel",
        "status": "Statut HTTP",
        "errorCode": "Code d'erreur",
        "origin": "Origine",
        "screen": "Écran",
        "time": "Horodatage",
        "reportId": "ID du signalement",
        "requestId": "ID de requête (log serveur)",
        "noTrace": "Aucun détail technique supplémentaire — ce signalement ne concernait pas un appel API.",
        "session": "Session",
        "turn": "Tour (seq)",
        "agent": "Agent"
      },
      "triage": {
        "owner": "Responsable",
        "unassigned": "Non attribué",
        "unassign": "Retirer",
        "status": "Statut",
        "assignTo": "Attribuer à",
        "pick": "Choisir …",
        "agents": "Agents",
        "channels": "Canaux",
        "history": "Historique",
        "thread": "Réponses",
        "noReplies": "Aucune réponse.",
        "reply": "Répondre",
        "replyPlaceholder": "Écrire une réponse …",
        "loadError": "Impossible de charger le suivi.",
        "eventFailed": "Impossible d'enregistrer l'action.",
        "replyFailed": "Impossible d'envoyer la réponse.",
        "unassignedEvent": "Attribution retirée",
        "statuses": {
          "open": "Ouvert",
          "in_progress": "En cours",
          "done": "Terminé",
          "cancelled": "Annulé"
        }
      },
      "consoleLog": "Derniers journaux du navigateur",
      "diagnostics": {
        "title": "Sous le capot",
        "turnRecords": "Enregistrements du tour",
        "prompt": "Prompt rendu (version épinglée)",
        "promptNote": "Rendu maintenant, pour vos outils ; la partie outils retenus peut différer de celle du tour de l'auteur du signalement.",
        "unavailable": "Contexte serveur indisponible : {{reason}}",
        "sessionReadError": "Lecture de la session impossible : {{reason}}"
      }
    }
  },
  "allocation": {
    "assign": "Attribuer",
    "assigning": "Attribution…",
    "notOnShift": "N'est plus en service.",
    "error": "Échec de l'attribution — réessayez.",
    "board": {
      "title": "Début du service",
      "progress": "{{done}} sur {{total}} attribués",
      "complete": "Tous les patients sont attribués — l'unité est transmise.",
      "nobodyOnShift": "Personne n'est encore en service — les patients pourront être attribués dès qu'une infirmière commence son service.",
      "proposalHint": "Proposition : {{nurse}}",
      "assign": "Attribuer",
      "change": "Modifier",
      "load_one": "{{count}} patient",
      "load_other": "{{count}} patients",
      "loadError": "Impossible de charger la répartition de l'unité.",
      "noWard": "Aucune unité n'est encore associée à votre profil.",
      "chatPlaceholder": "Demander une proposition de répartition…",
      "room": "Chambre {{room}}",
      "noRoom": "Sans chambre",
      "roomsList": "Chambres {{rooms}}",
      "assignRoom": "Attribuer toute la chambre",
      "assignRoomTo": "Attribuer toute la chambre à…",
      "split": "réparti",
      "spread": "Réparti sur plusieurs chambres",
      "partialAssign": "{{failed}} lits sur {{total}} n'ont pas pu être attribués.",
      "noPatients": "Aucun patient dans l'unité.",
      "progressLabel": "Progression de l'attribution des patients"
    }
  },
  "sessions": {
    "sharing": {
      "expiry": "Expire (facultatif)",
      "expiryHint": "Les partages limités dans le temps ne s’appliquent qu’à l’accès en lecture."
    }
  },
  "learn": {
    "homeTitle": "Apprentissage",
    "resume": {
      "label": "Continuer où vous en étiez",
      "untitled": "Votre conversation"
    },
    "targets": {
      "title": "Ce sur quoi je travaille",
      "loadError": "Impossible de charger vos objectifs.",
      "empty": {
        "title": "Aucun objectif pour l'instant",
        "description": "Votre responsable peut vous fixer un objectif sur une compétence — demandez à l'assistant sur quoi travailler ensuite."
      }
    },
    "recommended": {
      "title": "Recommandé pour vous",
      "loadError": "Impossible de charger le catalogue de quiz.",
      "empty": {
        "title": "Rien à reprendre pour l'instant",
        "description": "Dès qu'un de vos objectifs cite un quiz publié, il apparaît ici."
      },
      "becauseTarget": "Pour votre objectif : {{title}}"
    },
    "session": {
      "loading": "Chargement…"
    },
    "board": {
      "chatPlaceholder": "Posez une question sur votre apprentissage…"
    },
    "actions": {
      "exam": {
        "label": "Examen à venir",
        "submit": "Définir l’objectif",
        "dateLabel": "Date de l’examen",
        "request": "J'ai un examen sur {{topic}} le {{date}}. Fixe-moi un objectif sur la compétence {{topic}} avec cette date d'examen et crée-moi du matériel d'entraînement privé."
      },
      "practice": {
        "label": "Fais-moi réviser",
        "submit": "Créer",
        "request": "Crée-moi un quiz d'entraînement privé sur {{topic}}, fondé sur nos recommandations."
      },
      "topicPlaceholder": "Sur quel sujet ?",
      "topicLabel": "Sujet"
    }
  },
  "mentor": {
    "board": {
      "title": "Mentor",
      "switchUnit": "Changer d'unité",
      "newTarget": "Nouvel objectif",
      "summary": "{{trainees}} apprenant·e·s · {{openTargets}} en cours · {{achievedTargets}} atteints",
      "loadError": "Impossible de charger le tableau du mentor.",
      "chatPlaceholder": "Poser une question à l'assistant mentor…",
      "noTargets": "Aucun objectif défini pour l'instant.",
      "targetsHeading": "Objectifs",
      "targetCounts": "{{open}} en cours · {{achieved}} atteints",
      "showDetail": "Afficher les détails",
      "hideDetail": "Masquer les détails",
      "notFramed": "Cette conversation n’est pas encore rattachée à une unité.",
      "roster": {
        "title": "Apprenant·e·s",
        "empty": {
          "title": "Aucun·e apprenant·e pour l'instant",
          "description": "Les apprenant·e·s apparaissent ici dès qu'ils/elles rejoignent cette unité."
        }
      }
    },
    "targets": {
      "trainee": "Apprenant·e",
      "traineePlaceholder": "Choisir une personne…",
      "skill": "Compétence",
      "skillPlaceholder": "Choisir une compétence…",
      "skillsEmpty": "Le catalogue de compétences est vide : aucun objectif ne peut encore être fixé.",
      "skillsError": "Impossible de charger le catalogue de compétences.",
      "dueDate": "Pour quand",
      "drop": "Abandonner",
      "dropping": "Abandon…",
      "save": "Fixer l'objectif",
      "saving": "Enregistrement…"
    },
    "quiz": {
      "sectionTitle": "Quiz",
      "emptyTitle": "Pas encore de quiz",
      "empty": "Demande à l’assistance de générer un quiz à partir d’un document de ton unité, ou modélise-en un dans le Studio des protocoles.",
      "listErrorTitle": "Impossible de charger les quiz",
      "listError": "Le catalogue de quiz n’a pas pu être chargé.",
      "statusDraft": "Brouillon",
      "statusPublished": "Publié",
      "statusInReview": "En revue",
      "statusArchived": "Archivé"
    },
    "curricula": {
      "assignError": "Impossible d’assigner ce cursus. Veuillez réessayer.",
      "unassignError": "Impossible de retirer ce cursus. Veuillez réessayer."
    }
  }
}
